module.exports = __webpack_public_path__ + "img/layout_right_icon.9c1d5e25.svg";